import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b45b952a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latest-news" }
const _hoisted_2 = { class: "detail-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "en-title" }, "最新动态", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "NEWS INFORMATION", -1))
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "item split" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleDetail(_ctx.state.list[0]))),
          class: "item more"
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.state.list[0] ? _ctx.state.list[0].createTime : ''), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.state.list[0] ? _ctx.state.list[0].description : ''), 1),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleMore && _ctx.handleMore(...args)), ["stop"])),
            class: "btn"
          }, "查看更多")
        ]),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDetail(_ctx.state.list[1]))),
          class: "item bg"
        }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.state.list[1] ? _ctx.state.list[1].createTime : ''), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.state.list[1] ? _ctx.state.list[1].description : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleDetail(_ctx.state.list[2]))),
            class: "item-top"
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.state.list[2] ? _ctx.state.list[2].createTime : ''), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.state.list[2] ? _ctx.state.list[2].description : ''), 1)
          ]),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleDetail(_ctx.state.list[3]))),
            class: "item-bottom"
          }, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.state.list[3] ? _ctx.state.list[3].createTime : ''), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.state.list[3] ? _ctx.state.list[3].description : ''), 1)
          ])
        ])
      ])
    ])
  ]))
}